import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  deleteUser,
  User
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBPZrscYdsHHCX_90H1uT6KUZQIvLKAAMU",
  authDomain: "mindwise-81cbe.firebaseapp.com",
  projectId: "mindwise-81cbe",
  storageBucket: "mindwise-81cbe.firebasestorage.app",
  messagingSenderId: "243482417788",
  appId: "1:243482417788:web:f14bd3ac7ea7872bab47f9",
  measurementId: "G-ZZTXYYKK9D"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Google Sign In - Only allows existing users to sign in
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    
    // Check if this is a new user by checking the creation and last sign-in times
    const user = result.user;
    const isNewUser = user.metadata.creationTime === user.metadata.lastSignInTime;
    
    if (isNewUser) {
      // If it's a new user, delete the account immediately and return an error
      await deleteUser(user);
      return { 
        success: false, 
        error: 'No existing account found. Please sign in with your email and password or contact support.' 
      };
    }
    
    return { success: true, user };
  } catch (err: any) {
    console.error('Google sign in error:', err);
    let errorMessage = 'Failed to sign in with Google';
    
    // Handle specific error cases
    if (err.code === 'auth/account-exists-with-different-credential') {
      errorMessage = 'An account already exists with the same email but different sign-in method. Please try signing in with email and password.';
    } else if (err.code === 'auth/popup-closed-by-user') {
      errorMessage = 'Sign in was cancelled';
    } else if (err.code === 'auth/user-disabled') {
      errorMessage = 'This account has been disabled';
    } else if (err.code === 'auth/user-not-found') {
      errorMessage = 'No account found with this Google account';
    } else if (err.message) {
      errorMessage = err.message;
    }
    
    return { 
      success: false, 
      error: errorMessage 
    };
  }
};

// Email/Password Sign In
export const logInWithEmailAndPassword = async (email: string, password: string) => {
  try {
    const res = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: res.user };
  } catch (err: any) {
    console.error(err);
    return { success: false, error: err.message };
  }
};

// Register with Email/Password (disabled - only existing users can sign in)
export const registerWithEmailAndPassword = async (email: string, password: string) => {
  // First try to sign in the user
  try {
    const signInResult = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: signInResult.user };
  } catch (signInError: any) {
    // If sign in fails with user-not-found, don't create a new account
    if (signInError.code === 'auth/user-not-found') {
      return { 
        success: false, 
        error: 'No account found with this email. Please check your email or sign in with Google if you used that method.' 
      };
    }
    // For other errors, return the error message
    console.error(signInError);
    return { 
      success: false, 
      error: signInError.message || 'Failed to sign in. Please try again.' 
    };
  }
};

// Send password reset email
export const sendPasswordReset = async (email: string) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (err: any) {
    console.error(err);
    return { success: false, error: err.message };
  }
};

// Logout
export const logout = () => {
  signOut(auth);
};

// Delete account
export const deleteAccount = async (user: User) => {
  try {
    await deleteUser(user);
    return { success: true };
  } catch (err: any) {
    console.error(err);
    return { success: false, error: err.message };
  }
};

export { auth };
export default app;
